import React from "react";
import { Loader2 } from "lucide-react";
import BordeiroHeader from "./components/BordeiroHeader";
import BordeiroKanban from "./components/BordeiroKanban";
import ProducaoBordasCards from "./components/ProducaoBordasCards";
import { BordeiroProvider, useBordeiro } from "./context/BordeiroContext";

const BordeiroContent: React.FC = () => {
  const {
    resumo,
    loading,
    refreshing,
    headerStats,
    pendingCards,
    refreshNow,
    handleFinalizar,
    canFinalizar,
    showLojaSelector,
    lojaOptions,
    selectedLojaId,
    setSelectedLojaId,
  } = useBordeiro();

  if (loading) {
    return (
      <main className="flex h-[calc(100vh-4rem)] items-center justify-center">
        <Loader2 size={32} className="animate-spin text-primary" />
      </main>
    );
  }

  return (
    <main className="flex h-[calc(100vh-4rem)] flex-col">
      <BordeiroHeader
        dataReferencia={headerStats.dataReferencia}
        totalPendentes={headerStats.totalPendentes}
        totalFeitas={headerStats.totalFeitas}
        itens={resumo?.itens || []}
        onRefresh={refreshNow}
        isRefreshing={refreshing}
        showLojaSelector={showLojaSelector}
        lojaOptions={lojaOptions}
        selectedLojaId={selectedLojaId}
        onLojaChange={setSelectedLojaId}
      />

      <ProducaoBordasCards lojaId={selectedLojaId} />

      <BordeiroKanban
        resumo={resumo}
        pendingCards={pendingCards}
        canFinalizar={canFinalizar}
        onFinalizar={handleFinalizar}
      />
    </main>
  );
};

const Bordeiro: React.FC = () => {
  return (
    <BordeiroProvider>
      <BordeiroContent />
    </BordeiroProvider>
  );
};

export default Bordeiro;
